const LeftArrowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path fill="none" d="M-1 -1H25V25H-1z" />
    <path d="M19.415 21.17L10.245 12l9.17-9.17L16.585 0l-12 12 12 12 2.83-2.83z" />
  </svg>
);

export default LeftArrowIcon;
